import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { CallQueuesFieldConfig } from '../../../shared/models/generated/ziroModels';

@Injectable({ providedIn: 'root' })
export class TeamsCallQueuesFieldConfigResource {
  private http = inject(HttpClient);

  get(tenantId: number): Observable<CallQueuesFieldConfig> {
    return this.http.get<CallQueuesFieldConfig>(
      `/services/microsoft/call-queue-management/tenants/${tenantId}/field-configs`,
    );
  }
}
